import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Table, TableBody, TableCaption, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table';
import type { SemanticSection as SemanticSectionType } from '@/lib/semantic-content/types';

export default function SemanticSection({ section }: { section: SemanticSectionType }) {
  return (
    <section id={section.id} className="scroll-mt-28">
      <Card className="border-border/60 bg-background/80 shadow-none">
        <CardHeader>
          <CardTitle className="text-2xl md:text-3xl">{section.title}</CardTitle>
        </CardHeader>
        <CardContent className="space-y-6 text-base leading-7 text-muted-foreground">
          {section.paragraphs.map((paragraph) => (
            <p key={paragraph}>{paragraph}</p>
          ))}

          {section.bullets && section.bullets.length > 0 ? (
            <ul className="list-disc space-y-2 pl-6">
              {section.bullets.map((bullet) => (
                <li key={bullet}>{bullet}</li>
              ))}
            </ul>
          ) : null}

          {section.steps && section.steps.length > 0 ? (
            <ol className="list-decimal space-y-2 pl-6">
              {section.steps.map((step) => (
                <li key={step}>{step}</li>
              ))}
            </ol>
          ) : null}

          {section.table ? (
            <div className="rounded-xl border border-border/60 bg-card/50 p-4">
              <Table>
                {section.table.caption ? <TableCaption>{section.table.caption}</TableCaption> : null}
                <TableHeader>
                  <TableRow>
                    {section.table.columns.map((column) => (
                      <TableHead key={column}>{column}</TableHead>
                    ))}
                  </TableRow>
                </TableHeader>
                <TableBody>
                  {section.table.rows.map((row) => (
                    <TableRow key={row.join('|')}>
                      {row.map((cell, index) => (
                        <TableCell key={`${row[0]}-${index}`}>{cell}</TableCell>
                      ))}
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </div>
          ) : null}
        </CardContent>
      </Card>
    </section>
  );
}
